import { useState, useEffect } from 'react';
import useIsMobile from 'app/utils/hooks/useIsMobile';

const useStickyHeader = (headerRef: React.RefObject<HTMLDivElement>) => {
  const isMobile = useIsMobile();

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (!isMobile) return;

    const onScroll = () => {
      // this is the distance of headerRef from the top of the screen.
      // 10 is extra offset to make sure it wont immediately turn sticky for smoother interaction.
      const offset =
        headerRef.current.offsetTop + headerRef.current.offsetHeight + 210;
      if (window.scrollY > offset) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [isMobile]);

  return isSticky;
};

export default useStickyHeader;
